import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import ReportGridPage from "../components/ReportGridPage";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import MainPopup from "../popup-containers/MainPopup";
import {
  //ComplaintsAndIssuesHeader,
  RevenueExpenseDetailsHeader,
  RevenueExpenseHeader,
} from "../components/HeaderAttribute";

const RevenueExpense = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  const [currentData, setcurrentData] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewPopUp, setViewPopUp] = useState(false);
  const [bookingFields, setBookingFields] = useState({
    villaType: "",
    villa: "",
  });
  const [bookingFieldsError, setBookingFieldsError] = useState({
    villaTypeError: "",
    villaError: "",
  });

  const [showTable, setShowTable] = useState(false);

  const [bindVilla, setBindVillaDD] = useState([
    { value: "1", label: "Villa Serenity" },
    { value: "2", label: "Ocean Breeze" },
    { value: "3", label: "Meadow View" },
    { value: "4", label: "Whispering Pines" },
    { value: "5", label: "Green Hills" },
  ]);
  const [bindVillaType, setBindVillaType] = useState([
    { value: "1", label: "1 BHK" },
    { value: "2", label: "2 BHK" },
    { value: "3", label: "3 BHK" },
    { value: "4", label: "4 BHK" },
    { value: "5", label: "5 BHK" },
  ]);
  const RevenueExpenseDetailsData = [
  {
    sno: 1,
    date: "01-06-2025",
    villaType: "Deluxe",
    villaName: "Ocean Breeze",
    revenue: 12000,
    expense: 4500,
  },
  {
    sno: 2,
    date: "02-06-2025",
    villaType: "Premium",
    villaName: "Sunset Retreat",
    revenue: 15000,
    expense: 5000,
  },
  {
    sno: 3,
    date: "03-06-2025",
    villaType: "Standard",
    villaName: "Hill View",
    revenue: 8000,
    expense: 3000,
  },
  {
    sno: 4,
    date: "04-06-2025",
    villaType: "Luxury",
    villaName: "Coral Sands",
    revenue: 20000,
    expense: 7000,
  },
  {
    sno: 5,
    date: "05-06-2025",
    villaType: "Standard",
    villaName: "Palm Grove",
    revenue: 9000,
    expense: 3500,
  },
  {
    sno: 6,
    date: "06-06-2025",
    villaType: "Deluxe",
    villaName: "Seaside Villa",
    revenue: 11000,
    expense: 4000,
  },
  {
    sno: 7,
    date: "07-06-2025",
    villaType: "Premium",
    villaName: "Golden Bay",
    revenue: 17000,
    expense: 6000,
  },
  {
    sno: 8,
    date: "08-06-2025",
    villaType: "Luxury",
    villaName: "Blue Lagoon",
    revenue: 25000,
    expense: 9500,
  },
  {
    sno: 9,
    date: "09-06-2025",
    villaType: "Standard",
    villaName: "Green Hills",
    revenue: 7800,
    expense: 2800,
  },
  {
    sno: 10,
    date: "10-06-2025",
    villaType: "Deluxe",
    villaName: "Rainforest Escape",
    revenue: 12500,
    expense: 4800,
  },
];

  const revenueExpenseData = [
    {
      sno: 1,
      totalRevenue: 150000,
      totalExpense: 90000,
      netProfitLoss: 60000,
      noOfDays: 30,
    },
    // {
    //   sno: 2,
    //   totalRevenue: 120000,
    //   totalExpense: 100000,
    //   netProfitLoss: 20000,
    //   noOfDays: 28,
    // },
    // {
    //   sno: 3,
    //   totalRevenue: 180000,
    //   totalExpense: 110000,
    //   netProfitLoss: 70000,
    //   noOfDays: 31,
    // },
    // {
    //   sno: 4,
    //   totalRevenue: 95000,
    //   totalExpense: 105000,
    //   netProfitLoss: -10000,
    //   noOfDays: 30,
    // },
    // {
    //   sno: 5,
    //   totalRevenue: 200000,
    //   totalExpense: 150000,
    //   netProfitLoss: 50000,
    //   noOfDays: 29,
    // },
    // {
    //   sno: 6,
    //   totalRevenue: 175000,
    //   totalExpense: 125000,
    //   netProfitLoss: 50000,
    //   noOfDays: 31,
    // },
    // {
    //   sno: 7,
    //   totalRevenue: 220000,
    //   totalExpense: 200000,
    //   netProfitLoss: 20000,
    //   noOfDays: 30,
    // },
    // {
    //   sno: 8,
    //   totalRevenue: 195000,
    //   totalExpense: 145000,
    //   netProfitLoss: 50000,
    //   noOfDays: 28,
    // },
    // {
    //   sno: 9,
    //   totalRevenue: 160000,
    //   totalExpense: 130000,
    //   netProfitLoss: 30000,
    //   noOfDays: 30,
    // },
    // {
    //   sno: 10,
    //   totalRevenue: 210000,
    //   totalExpense: 175000,
    //   netProfitLoss: 35000,
    //   noOfDays: 31,
    // },
  ];

  const handleClose = () => {
    setViewPopUp(false);
  };

  const handlePopupClick = () => {
    setViewPopUp(true);
  };
  const GoButton = async () => {
    const VillaTypeValidate = bookingFields.villaType
      ? ""
      : "Select Villa Type";

    const villaValidate = bookingFields.villa ? "" : "Select Villa Name";

    setBookingFieldsError({
      ...bookingFieldsError,
      villaTypeError: VillaTypeValidate,
      villaError: villaValidate,
    });

    if (!villaValidate && !VillaTypeValidate) {
      setShowTable(true);
    } else {
    }
  };
  const handleExport = () => {
    // const dateRange = {
    //     fromDate: fromDate,
    //     toDate: toDate,
    // };
    // const selectedOptionsData = {
    //     branchProjectData:
    //         branchProjectNamesList.length > 0
    //             ? branchProjectNamesList.toString()
    //             : branchName,
    //     sdpData: sdpNamesList.toString(),
    //     areaData: areaNamesList.toString(),
    //     serviceCategoryData: serviceCategoryNameList.toString(),
    //     serviceSubCategoryData: serviceSubCategoryNameList.toString(),
    //     servicesData: serviceNameList.toString(),
    // };
    // exportData(
    //     ageGenderChildrenReportHeader.map((column) => column.title),
    //     bindAgeGendeChildrenData,
    //     dateRange,
    //     selectedOptionsData
    // );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const titleRow = [
      {
        v: "Age&Gender - Children",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Date range row with merged cells
    const dateRangeRow = [
      { v: "" },
      {
        v: "From Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: formatDate(dateRange.fromDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
      {
        v: "To Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "left" },
        },
      },
      {
        v: formatDate(dateRange.toDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
    ];
    // Branch information row with merged cells
    const branchRow = [
      { v: "" },

      {
        v: "Branch/Project:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.branchProjectData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "S.D.P.:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.sdpData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Area:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.areaData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    //Services information row with merged cells
    const servicesRow = [
      { v: "" },
      {
        v: "Service Category",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.serviceCategoryData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Service Sub-Category",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.serviceSubCategoryData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Services",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.servicesData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    // Add empty row for spacing
    const spacingRow = [{ v: "" }];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),
      {
        v: "Total",
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "right" },
        },
      },
    ];
    // Initialize column totals
    const columnTotals = {
      FemaleLessthan1: 0,
      MaleLessthan1: 0,
      OtherLessthan1: 0,
      FemaleAge01to02: 0,
      MaleAge01to02: 0,
      OtherAge01to02: 0,
      FemaleAge03to05: 0,
      MaleAge03to05: 0,
      OtherAge03to05: 0,
      FemaleAge06to09: 0,
      MaleAge06to09: 0,
      OtherAge06to09: 0,
      FemaleAge10andAbove: 0,
      MaleAge10andAbove: 0,
      OtherAge10andAbove: 0,
    };

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      // Calculate row total for numeric fields
      const rowTotal =
        Number(rowData.FemaleLessthan1 || 0) +
        Number(rowData.MaleLessthan1 || 0) +
        Number(rowData.OtherLessthan1 || 0) +
        Number(rowData.FemaleAge01to02 || 0) +
        Number(rowData.MaleAge01to02 || 0) +
        Number(rowData.OtherAge01to02 || 0) +
        Number(rowData.FemaleAge03to05 || 0) +
        Number(rowData.MaleAge03to05 || 0) +
        Number(rowData.OtherAge03to05 || 0) +
        Number(rowData.FemaleAge06to09 || 0) +
        Number(rowData.MaleAge06to09 || 0) +
        Number(rowData.OtherAge06to09 || 0) +
        Number(rowData.FemaleAge10andAbove || 0) +
        Number(rowData.MaleAge10andAbove || 0) +
        Number(rowData.OtherAge10andAbove || 0);
      // Add to column totals
      columnTotals.FemaleLessthan1 += Number(rowData.FemaleLessthan1 || 0);
      columnTotals.MaleLessthan1 += Number(rowData.MaleLessthan1 || 0);
      columnTotals.OtherLessthan1 += Number(rowData.OtherLessthan1 || 0);
      columnTotals.FemaleAge01to02 += Number(rowData.FemaleAge01to02 || 0);
      columnTotals.MaleAge01to02 += Number(rowData.MaleAge01to02 || 0);
      columnTotals.OtherAge01to02 += Number(rowData.OtherAge01to02 || 0);
      columnTotals.FemaleAge03to05 += Number(rowData.FemaleAge03to05 || 0);
      columnTotals.MaleAge03to05 += Number(rowData.MaleAge03to05 || 0);
      columnTotals.OtherAge03to05 += Number(rowData.OtherAge03to05 || 0);
      columnTotals.FemaleAge06to09 += Number(rowData.FemaleAge06to09 || 0);
      columnTotals.MaleAge06to09 += Number(rowData.MaleAge06to09 || 0);
      columnTotals.OtherAge06to09 += Number(rowData.OtherAge06to09 || 0);
      columnTotals.FemaleAge10andAbove += Number(
        rowData.FemaleAge10andAbove || 0
      );
      columnTotals.MaleAge10andAbove += Number(rowData.MaleAge10andAbove || 0);
      columnTotals.OtherAge10andAbove += Number(
        rowData.OtherAge10andAbove || 0
      );
      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Branch,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.SDP_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.AreaName_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Services_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: Number(rowData.FemaleLessthan1 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleLessthan1 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherLessthan1 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.FemaleAge01to02 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge01to02 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge01to02 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.FemaleAge03to05 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge03to05 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge03to05 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.FemaleAge06to09 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge06to09 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge06to09 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.FemaleAge10andAbove || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge10andAbove || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge10andAbove || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        // Row total
        {
          v: rowTotal,
          t: "n",
          s: {
            ...baseStyle,
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
      ];
    });

    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
      alignment: { horizontal: "right" },
      numFmt: "0",
    };

    const grandTotal = Object.values(columnTotals).reduce(
      (sum, val) => sum + val,
      0
    );

    const totalsRow = [
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      {
        v: "Total",
        s: { ...totalsRowStyle, alignment: { horizontal: "left" } },
      },
      { v: "", s: totalsRowStyle },
      { v: columnTotals.FemaleLessthan1, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleLessthan1, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherLessthan1, t: "n", s: totalsRowStyle },
      { v: columnTotals.FemaleAge01to02, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge01to02, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge01to02, t: "n", s: totalsRowStyle },
      { v: columnTotals.FemaleAge03to05, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge03to05, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge03to05, t: "n", s: totalsRowStyle },
      { v: columnTotals.FemaleAge06to09, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge06to09, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge06to09, t: "n", s: totalsRowStyle },
      { v: columnTotals.FemaleAge10andAbove, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge10andAbove, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge10andAbove, t: "n", s: totalsRowStyle },

      // Grand total
      {
        v: grandTotal,
        t: "n",
        s: {
          ...totalsRowStyle,
          font: { bold: true, color: { rgb: "2D2D6E" } },
        },
      },
    ];
    // Combine all rows
    // const wsData = [titleRow, headerRow, ...dataRows, totalsRow];
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      servicesRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 30 }, // Branch
      { width: 30 }, // IPC  No
      { width: 30 }, // Gender
      { width: 30 }, // Topics1
      { width: 30 }, // Topics2
      { width: 30 }, // Topics3
      { width: 30 }, // Topics4
      { width: 30 }, // Topics5
      { width: 30 }, // Topics6
      { width: 30 }, // Topics7
      { width: 30 }, // Topics8
      { width: 30 }, // Topics9
      { width: 30 }, // Topics10

      { width: 30 }, // Row Total
      { width: 30 }, // Topics8
      { width: 30 }, // Topics9
      { width: 30 }, // Topics10
      { width: 30 }, // Topics10

      { width: 30 }, // Row Total
    ];

    // // Border style for all cells
    // const borderStyle = {
    //   border: {
    //     top: { style: "thin", color: { rgb: "00000000" } },
    //     bottom: { style: "thin", color: { rgb: "00000000" } },
    //     left: { style: "thin", color: { rgb: "00000000" } },
    //     right: { style: "thin", color: { rgb: "00000000" } },
    //   },
    // };

    // // Apply styles
    // // Title row
    // const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    // ws[titleCell].s = titleRow[0].s;

    // // Header row
    // headerRow.forEach((cell, colIndex) => {
    //   const cellAddress = XLSX.utils.encode_cell({ r: 1, c: colIndex });
    //   ws[cellAddress].s = { ...cell.s, ...borderStyle };
    // });

    // // Data rows
    // dataRows.forEach((row, rowIndex) => {
    //   row.forEach((cell, colIndex) => {
    //     const cellAddress = XLSX.utils.encode_cell({
    //       r: rowIndex + 2,
    //       c: colIndex,
    //     });
    //     ws[cellAddress] = {
    //       v: cell.v,
    //       t: cell.t,
    //       s: { ...cell.s, ...borderStyle },
    //     };
    //   });
    // });

    // // Totals row
    // totalsRow.forEach((cell, colIndex) => {
    //   const cellAddress = XLSX.utils.encode_cell({
    //     r: dataRows.length + 2,
    //     c: colIndex,
    //   });
    //   ws[cellAddress] = {
    //     v: cell.v,
    //     t: cell.t,
    //     s: { ...cell.s, ...borderStyle },
    //   };
    // });

    // Set row heights for wrapped content
    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "Age&Gender - Children.xlsx");
  };

  const downloadPDF = () => {
    // const doc = new jsPDF("landscape");
    // const logoWidth = 30;
    // const logoHeight = 14;
    // doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);
    // const headers = ageGenderChildrenReportHeader.map((column) => column.title);
    // const data = bindAgeGendeChildrenData.map((rowData, index) => {
    //     return [
    //         index + 1,
    //         rowData.Branch,
    //         rowData.Services_en,
    //         rowData.FemaleLessthan1,
    //         rowData.MaleLessthan1,
    //         rowData.OtherLessthan1,
    //         rowData.FemaleAge01to02,
    //         rowData.MaleAge01to02,
    //         rowData.OtherAge01to02,
    //         rowData.FemaleAge03to05,
    //         rowData.MaleAge03to05,
    //         rowData.OtherAge03to05,
    //         rowData.FemaleAge06to09,
    //         rowData.MaleAge06to09,
    //         rowData.OtherAge06to09,
    //         rowData.FemaleAge10andAbove,
    //         rowData.MaleAge10andAbove,
    //         rowData.OtherAge10andAbove,
    //     ];
    // });
    // // Create the table with headers and data
    // doc.autoTable({
    //     head: [headers],
    //     body: data,
    //     startY: 30,
    //     styles: {
    //         fontSize: 7, // Reduced font size
    //         lineColor: "black",
    //         lineWidth: 0.2,
    //         halign: "center", // Align text to center
    //         valign: "middle", // Align text vertically in the middle
    //         cellPadding: 2, // Add padding to cells
    //         overflow: "linebreak", // Allow text to wrap within cells
    //     },
    //     headStyles: {
    //         fillColor: "#2d2d6e",
    //         textColor: [255, 255, 255],
    //     },
    //     alternateRowStyles: {
    //         fillColor: [240, 240, 240], // Light gray color for alternate rows
    //     },
    //     columnStyles: {
    //         0: { cellWidth: 10 }, // Index column
    //         1: { cellWidth: "auto" }, // Auto adjust width
    //         2: { cellWidth: "auto" }, // Auto adjust width
    //         3: { cellWidth: "auto" }, // Auto adjust width
    //         4: { cellWidth: "auto" }, // Auto adjust width
    //         5: { cellWidth: "auto" }, // Auto adjust width
    //         6: { cellWidth: "auto" }, // Auto adjust width
    //         7: { cellWidth: "auto" }, // Auto adjust width
    //         8: { cellWidth: "auto" }, // Auto adjust width
    //         9: { cellWidth: "auto" }, // Auto adjust width
    //         10: { cellWidth: 15 }, // Age
    //         11: { cellWidth: 15 }, // Gender
    //         12: { cellWidth: "auto" }, // Auto adjust width
    //         13: { cellWidth: "auto" }, // Auto adjust width
    //         14: { cellWidth: "auto" }, // Auto adjust width
    //         15: { cellWidth: "auto" }, // Auto adjust width
    //         16: { cellWidth: "auto" }, // Auto adjust width
    //     },
    // });
    // doc.save("Age&Gender - Children.pdf");
  };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const bookingFieldsChange = (value, name) => {
    setBookingFields({
      ...bookingFields,
      [name]: value,
    });
  };

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Revenue - Expense`}</div>
            </div>
            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setFromDate(e.target.value);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setShowTable(false);

                  setToDate(e.target.value);
                }}
              />
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Villa Type"
                  filteredOptions={bindVillaType}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    bookingFields.villaType?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="villaType"
                  selectedOptions={bookingFields.villaType}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    bookingFieldsChange(e, "villaType");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {bookingFieldsError.villaTypeError && (
                  <span className="text-red-500">
                    {bookingFieldsError.villaTypeError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Villa Name"
                  filteredOptions={bindVilla}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    bookingFields.villa?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="villa"
                  selectedOptions={bookingFields.villa}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    bookingFieldsChange(e, "villa");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {bookingFieldsError.villaError && (
                  <span className="text-red-500">
                    {bookingFieldsError.villaError}
                  </span>
                )}
              </div>
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (revenueExpenseData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={RevenueExpenseHeader}
                records={revenueExpenseData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
                handlePopupClick={handlePopupClick}
                xScroll={"max-md:w-fit w-fit w-full"}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
      <MainPopup
        popUpOpen={viewPopUp}
        setpopUpOpen={setViewPopUp}
        handlePopupClick={true}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div className="p-4">
            <ReportGridPage
              title=""
              header={RevenueExpenseDetailsHeader}
              records={RevenueExpenseDetailsData}
              handleExport={handleExport}
              handlePDF={downloadPDF}
              handlePopupClick={handlePopupClick}
              xScroll={"max-md:w-fit w-fit w-full"}
            />
          </div>
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default RevenueExpense;
